import { PacmanLoader } from 'react-spinners';

const ContentSpinner = props => {
  return (
    <div className="text-center pt-5">
      <PacmanLoader color="#b887f1" {...props} />
    </div>
  );
};

export default ContentSpinner;
